
import { Plugin } from "prosemirror-state";
import { Schema } from 'prosemirror-model';
import { CloudinaryImageResponse } from "../../../../../utils/cloudinary";

const createImageNode = (image: CloudinaryImageResponse, schema: Schema) => schema.nodes.image.create({
	src: image.url,
	publicId: image.public_id,
	alt: image.original_filename
});

export type UploadFn = (image: File) => Promise<CloudinaryImageResponse>;

export const uploadImagePlugin = (upload: UploadFn) => {
	return new Plugin({
		props: {
			handlePaste(view, event) {
				const items = Array.from(event.clipboardData?.items || []);
				const { schema } = view.state;

				items.forEach(item => {
					const image = item.getAsFile();

					if (item.type.indexOf("image") === 0) {
						event.preventDefault();

						if (image) {
							upload(image).then(uploadedImage => {
								const node = createImageNode(uploadedImage, schema)
								const transaction = view.state.tr.replaceSelectionWith(node);
								view.dispatch(transaction);
							});
						}
					}
				});

				return false;
			},
			// @ts-ignore
			handleDOMEvents: {
				drop(view, event) {
					const hasFiles = event.dataTransfer?.files?.length;

					if (!hasFiles) {
						return false;
					}

					const images = Array.from(event!.dataTransfer!.files).filter(file => /image/i.test(file.type));

					if (images.length === 0) {
						return false;
					}

					event.preventDefault();

					const { schema } = view.state;
					const coordinates = view.posAtCoords({ left: event.clientX, top: event.clientY });

					images.forEach(async image => {
						const uploadedImage = await upload(image)
						const node = createImageNode(uploadedImage, schema)
						const transaction = view.state.tr.insert(coordinates!.pos, node);
						view.dispatch(transaction);
					});

					return false;
				},
			},
		},
	});
};